import { useMediaQuery } from "react-responsive";
import FooterBrands from "components/falabella/jobs/FooterBrands";
import BrandCarousel from "components/falabella/jobs/BrandCarousel/BrandCarousel";
const directionButtons = (direction) => {
  return (
    <span
      aria-hidden="true"
      className={
        direction === "Next"
          ? "fe fe-arrow-right size-icon"
          : "fe fe-arrow-left size-icon"
      }
    ></span>
  );
};

const Footer = (props) => {
  const isLargeScreen = useMediaQuery({ minWidth: 996 });

  return (
    <div id="footer">
      <div className="footer">
    
       
        {isLargeScreen ? (
          <FooterBrands />
        ) : (
          <div className="pb-15">
            <BrandCarousel
              height="9vw"
              controls
              nextIcon={directionButtons("Next")}
              prevIcon={directionButtons("prevew")}
            />
          </div>
        )}
      </div>
    </div>
  );
};
Footer.propTypes = {};

export default Footer;
